import React from 'react'
import styled from '@emotion/styled'
import * as mixins from 'view/styles/mixins'
import { LabelPosition } from 'view/styles/constants'

interface IconLabelProps {
  icon: JSX.Element
  className?: string
  label?: string
  labelPosition?: LabelPosition
}

interface IconLabelStyledProps {
  labelPosition?: LabelPosition
}

const IconLabelStyled = styled.div`
  ${(props: IconLabelStyledProps) => mixins.labelLayout(props.labelPosition)};
`

export class IconLabel extends React.Component<IconLabelProps> {
  render() {
    const { icon, className, label, labelPosition } = this.props
    return (
      <IconLabelStyled className={className} labelPosition={labelPosition}>
        {icon}
        {label && <label>{label}</label>}
      </IconLabelStyled>
    )
  }
}
